module.exports = __webpack_public_path__ + "static/img/PSS-50A.a8a2bd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PSS-50A.png
// module id = clfk
// module chunks = 1